import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import avatar from "../../../assets/images/default-user.webp";

export default function CreateUser({ setShowForm, setData, data }) {
  const AuthToken = localStorage.getItem("AuthUser");

  const initialFormState = {
    name: "",
    email: "",
    phone: "",
    password: "",
    role_id: "",
    org_id: "",
    permissions: [],
    avatar: "",
  };

  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setFormData(initialFormState);
    setErrors({});
  }, []);

  const handleChange = (e) => {
    if (e.target.name === "avatar") {
      setFormData({ ...formData, avatar: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Invalid email format";
    if (!formData.phone) newErrors.phone = "Mobile number is required";
    if (!formData.password) newErrors.password = "Password is required";
    else if (formData.password.length < 6) newErrors.password = "Password must be 6 characters";
    if (!formData.avatar) newErrors.avatar = "Avatar is required";
    if (!formData.role_id) newErrors.role_id = "User role is required";
    if (!formData.org_id) newErrors.org_id = "Organization is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const submitAddUser = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const apiFormData = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "permissions") {
        formData.permissions.forEach((p) => apiFormData.append("permissions[]", p));
      } else {
        apiFormData.append(key, formData[key]);
      }
    });

    try {
      axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/create-user",
        apiFormData
      );
      setData((data) => ({ ...data, 
        users: [...data.users, response.data.user] }));
      setShowForm(false);
    } catch (err) {
      console.error("Error adding user:", err);
    }
  };

  // Permission options
  const permissionOptions =
    data?.permissions?.map((p) => ({
      value: p.id,
      label: p.name.charAt(0).toUpperCase() + p.name.slice(1),
    })) || [];

  return (
    <form onSubmit={submitAddUser} className="container">
      <h3 className="mb-4 text-center px-3">Add User</h3>

      <div className="row">
        <div className="col-md-6">
          <div className="mb-3 text-center">
            <img
              src={formData.avatar ? URL.createObjectURL(formData.avatar) : avatar}
              alt="Avatar Preview"
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </div>

          <div className="mb-3">
            <label>Avatar</label>
            <input
              type="file"
              className="form-control"
              name="avatar"
              onChange={handleChange}
            />
            <span className="text-danger">{errors.avatar}</span>
          </div>

          <div className="mb-3">
            <label>Role</label>
            <select
              className="form-select"
              name="role_id"
              value={formData.role_id}
              onChange={handleChange}
            >
              <option value="">Select Role</option>
              {data.roles?.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.name}
                </option>
              ))}
            </select>
            <span className="text-danger">{errors.role_id}</span>
          </div>

          <div className="mb-3">
            <label>Permissions</label>
            <Select
              isMulti
              options={permissionOptions}
              value={permissionOptions.filter((opt) =>
                formData.permissions.includes(opt.value)
              )}
              onChange={(selected) =>
                setFormData({
                  ...formData,
                  permissions: selected ? selected.map((s) => s.value) : [],
                })
              }
                   styles={{
    container: (base) => ({
      ...base,
      width: "100%",       
      maxWidth: "400px",  
    }),
    control: (base) => ({
      ...base,
      minHeight: "38px",   
      borderRadius: "0.375rem",
      borderColor: "#ced4da",
    }),
  }}
            />
          </div>
        </div>

        {/* Right Column */}
        <div className="col-md-6">
          <div className="mb-3">
            <label>Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
            <span className="text-danger">{errors.name}</span>
          </div>

          <div className="mb-3">
            <label>Phone</label>
            <input
              type="text"
              className="form-control"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
            <span className="text-danger">{errors.phone}</span>
          </div>

          <div className="mb-3">
            <label>Email</label>
            <input
              type="text"
              className="form-control"
              name="email"
              autoComplete="off"
              value={formData.email}
              onChange={handleChange}
            />
            <span className="text-danger">{errors.email}</span>
          </div>

          <div className="mb-3">
            <label>Password</label>
            <input
              type="password"
              className="form-control"
              name="password"
              autoComplete="new-password"
              value={formData.password}
              onChange={handleChange}
            />
            <span className="text-danger">{errors.password}</span>
          </div>

          <div className="mb-3">
            <label>Organization</label>
            <select
              className="form-select"
              name="org_id"
              value={formData.org_id}
              onChange={handleChange}
            >
              <option value="">Select Organization</option>
              {data.organizations?.map((org) => (
                <option key={org.id} value={org.id}>
                  {org.name}
                </option>
              ))}
            </select>
            <span className="text-danger">{errors.org_id}</span>
          </div>
        </div>
      </div>

      <div className="text-center mt-4">
        <button type="submit" className="btn btn-success">
          Add User
        </button>
      </div>
    </form>
  );
}
